import { ViewModel } from './model';
import html from './template.html';
import './style.less';

ko.components.register('confirm-dialog', {
  viewModel: {
    createViewModel: (params, componentInfo) => {
      let element = componentInfo.element;
      element.classList.add('confirm-dialog');

      return new ViewModel(params, element);
    },
  },
  template: html,
});